import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import StatFullTemplate from './StatFullTemplate';
import ClientProvider from './client';
export default createDemo(import.meta.url, StatFullTemplate, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/creating-themed-components/demos/stat-full-template/StatFullTemplate.tsx",
    "fileName": "StatFullTemplate.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Stack from '@mui/material/Stack';\nimport { styled, useThemeProps } from '@mui/material/styles';\n\nexport interface StatProps {\n  value: number | string;\n  unit: string;\n  variant?: 'outlined';\n}\n\ninterface StatOwnerState extends StatProps {\n  // …key value pairs for the internal state that you want to style the slot\n  // but don't want to expose to the users\n}\n\nconst StatRoot = styled('div', {\n  name: 'MuiStat',\n  slot: 'root',\n})<{ ownerState: StatOwnerState }>(({ theme }) => ({\n  display: 'flex',\n  flexDirection: 'column',\n  gap: theme.spacing(0.5),\n  padding: theme.spacing(3, 4),\n  backgroundColor: theme.palette.background.paper,\n  borderRadius: theme.shape.borderRadius,\n  boxShadow: theme.shadows[2],\n  letterSpacing: '-0.025em',\n  fontWeight: 600,\n  variants: [\n    {\n      props: {\n        variant: 'outlined',\n      },\n      style: {\n        border: `2px solid ${theme.palette.divider}`,\n        boxShadow: 'none',\n      },\n    },\n  ],\n  ...theme.applyStyles('dark', {\n    backgroundColor: 'inherit',\n  }),\n}));\n\nconst StatValue = styled('div', {\n  name: 'MuiStat',\n  slot: 'value',\n})<{ ownerState: StatOwnerState }>(({ theme }) => ({\n  ...theme.typography.h3,\n}));\n\nconst StatUnit = styled('div', {\n  name: 'MuiStat',\n  slot: 'unit',\n})<{ ownerState: StatOwnerState }>(({ theme }) => ({\n  ...theme.typography.body2,\n  color: theme.palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    color: 'inherit',\n  }),\n}));\n\nconst Stat = React.forwardRef<HTMLDivElement, StatProps>(\n  function Stat(inProps, ref) {\n    const props = useThemeProps({ props: inProps, name: 'MuiStat' });\n    const { value, unit, variant, ...other } = props;\n\n    const ownerState = { ...props, variant };\n\n    return (\n      <StatRoot ref={ref} ownerState={ownerState} {...other}>\n        <StatValue ownerState={ownerState}>{value}</StatValue>\n        <StatUnit ownerState={ownerState}>{unit}</StatUnit>\n      </StatRoot>\n    );\n  },\n);\n\nexport default function StatFullTemplate() {\n  return (\n    <Stack direction=\"row\" spacing={2}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Stat value=\"1.9M\" unit=\"Favorites\" />\n      <Stat value=\"5.1M\" unit=\"Views\" variant=\"outlined\" />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 86,
        "focusedLines": 2,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Stack from '@mui/material/Stack';\nimport { styled, useThemeProps } from '@mui/material/styles';\n\nexport interface StatProps {\n  value: number | string;\n  unit: string;\n  variant?: 'outlined';\n}\n\ninterface StatOwnerState extends StatProps {\n  // …key value pairs for the internal state that you want to style the slot\n  // but don't want to expose to the users\n}\n\nconst StatRoot = styled('div', {\n  name: 'MuiStat',\n  slot: 'root',\n})<{ ownerState: StatOwnerState }>(({ theme }) => ({\n  display: 'flex',\n  flexDirection: 'column',\n  gap: theme.spacing(0.5),\n  padding: theme.spacing(3, 4),\n  backgroundColor: theme.palette.background.paper,\n  borderRadius: theme.shape.borderRadius,\n  boxShadow: theme.shadows[2],\n  letterSpacing: '-0.025em',\n  fontWeight: 600,\n  variants: [\n    {\n      props: {\n        variant: 'outlined',\n      },\n      style: {\n        border: `2px solid ${theme.palette.divider}`,\n        boxShadow: 'none',\n      },\n    },\n  ],\n  ...theme.applyStyles('dark', {\n    backgroundColor: 'inherit',\n  }),\n}));\n\nconst StatValue = styled('div', {\n  name: 'MuiStat',\n  slot: 'value',\n})<{ ownerState: StatOwnerState }>(({ theme }) => ({\n  ...theme.typography.h3,\n}));\n\nconst StatUnit = styled('div', {\n  name: 'MuiStat',\n  slot: 'unit',\n})<{ ownerState: StatOwnerState }>(({ theme }) => ({\n  ...theme.typography.body2,\n  color: theme.palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    color: 'inherit',\n  }),\n}));\n\nconst Stat = React.forwardRef<HTMLDivElement, StatProps>(\n  function Stat(inProps, ref) {\n    const props = useThemeProps({ props: inProps, name: 'MuiStat' });\n    const { value, unit, variant, ...other } = props;\n\n    const ownerState = { ...props, variant };\n\n    return (\n      <StatRoot ref={ref} ownerState={ownerState} {...other}>\n        <StatValue ownerState={ownerState}>{value}</StatValue>\n        <StatUnit ownerState={ownerState}>{unit}</StatUnit>\n      </StatRoot>\n    );\n  },\n);\n\nexport default function StatFullTemplate() {\n  return (\n    <Stack direction=\"row\" spacing={2}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Stat value=\"1.9M\" unit=\"Favorites\" />\n      <Stat value=\"5.1M\" unit=\"Views\" variant=\"outlined\" />\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 82
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Stat"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "1.9M",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "unit"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Favorites",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 83
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Stat"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "5.1M",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "unit"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Views",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "outlined",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 86,
    "focusedLines": 2,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Stack",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
